<template>
    <div>
        <v-card class="soft-shadow pa-1 mb-4">
            <v-card-title class="d-block">
                <div class="d-flex justify-space-between">
                    <div class="d-flex align-center">

                        <v-btn icon :color="currentDirectory ? 'teal darken-3' : 'text'" :disabled="!currentDirectory" @click="navigateToPath(currentDirectory && currentDirectory.parent_category_id ? `/directories/${currentDirectory.parent_category_id}` : '/')">
                            <v-icon v-if="!currentDirectory || !currentDirectory.parent_category_id">mdi-home</v-icon>
                            <v-icon v-else>mdi-folder-move{{!currentDirectory ? '-outline' : ''}}</v-icon>
                        </v-btn>

                        <v-btn @click.prevent="navigateToPath('/')" text color="strong-text" dense style="font-size: 1.1rem" class="px-2">
                            <!-- <v-icon size="22" left>mdi-home-outline</v-icon> -->
                            بنك اﻷسئلة
                        </v-btn>

                        <template v-if="currentDirectory" >

                            <template v-for="(dir) in currentDirectory.full_path_dirs">
                                <v-icon :key="'icon' + dir.id" color="grey">mdi-chevron-left</v-icon>

                                <v-btn @click.prevent="navigateToPath('/directories/' + dir.id)" text color="strong-text" :key="'button' + dir.id" v-ripple="dir.id !== currentDirectory.id" dense style="font-size: 1.1rem; text-transform: none; min-width: auto!important" class="px-2 strong-text--text d-flex align-center">
                                    {{dir.name}}
                                </v-btn>
                            </template>
                        </template>
                    </div>
                    <div>
                        <v-menu bottom left :offset-y="true" transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn @mousedown.stop @mouseover.stop @touchstart.stop @click.stop v-bind="attrs" v-on="on" depressed>
                                    <span>إضافة</span>
                                    <v-icon right>mdi-menu-down</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense min-width="150" >
                                <v-list-item dense @click="createDirectoryDialog = true">
                                    <v-list-item-icon class="me-1">
                                        <v-icon color="primary" size="19">mdi-folder-plus-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title class="medium-text">
                                            <span>تصنيف جديد</span>
                                            <span class="ms-3 small-text muted--text">Shift + N</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item dense :to="{name: 'new-question', query: currentDirectory ? {category: currentDirectory.id} : {}}">
                                    <v-list-item-icon class="me-1">
                                        <v-icon color="primary" size="19">mdi-file-plus-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title class="medium-text">
                                            <span>سؤال جديد</span>
                                            <!-- <span class="ms-3 small-text muted--text">Shift + Q</span> -->
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </div>

                <v-divider class="mt-3"></v-divider>
            </v-card-title>
            <v-card-text :class="{'px-0': phoneOnly}">
                <div v-if="(directories && directories.length) || (questionsItems && questionsItems.length)">
                    <v-list v-if="directories && directories.length" two-line class="pa-0 mb-3">
                        <v-subheader style="height: auto" class="mb-1">التصنيفات</v-subheader>
                        <v-list-item v-for="dir in directories" :key="dir.id" v-ripple="phoneOnly" @click.prevent="navigateToPath('/directories/' + dir.id)" class="directories-item py-1">
                            <v-list-item-icon>
                                <v-icon :color="dir.type === 'default' ? 'blue darken-1' : (dir.type && dir.type.search('teacher') !== -1 ? 'teal' : 'blue-grey lighten-1')">mdi-folder</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{dir.name}}</v-list-item-title>
                                <v-list-item-subtitle>
                                    <div v-if="dir.child_categories_count || dir.questions_count" class="d-flex">
                                        <span v-if="dir.child_categories_count" class="me-3">
                                            <v-icon class="me-1" size="14">mdi-folder-multiple-outline</v-icon>
                                            <span>{{dir.child_categories_count}} مجلدات</span>
                                        </span>
                                        <span v-if="dir.questions_count">
                                            <v-icon class="me-1" size="14">mdi-file-question-outline</v-icon>
                                            <span>{{dir.questions_count}} أسئلة</span>
                                        </span>
                                    </div>
                                    <span v-else>مجلد فارغ</span>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-menu bottom left :offset-y="true" transition="slide-y-transition">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn icon @mousedown.stop @mouseover.stop @touchstart.stop @click.stop v-bind="attrs" v-on="on">
                                            <v-icon>mdi-dots-vertical</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list dense min-width="150" >
                                        <v-list-item dense @click="openRenameDirectoryDialog(dir)">
                                            <v-list-item-icon class="me-1">
                                                <v-icon color="muted" size="19">mdi-pencil</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title class="medium-text">إعادة تسمية</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-list-item dense @click="deleteDirectory = dir; deleteDirectoryDialog = true;">
                                            <v-list-item-icon class="me-1">
                                                <v-icon color="error" size="19">mdi-delete</v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-content>
                                                <v-list-item-title class="medium-text">حذف</v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </v-list-item-icon>
                        </v-list-item>
                    </v-list>


                    <v-list v-if="questionsItems && questionsItems.length" two-line class="pa-0 mb-3">
                        <v-subheader style="height: auto" class="mb-1">اﻷسئلة</v-subheader>
                        <v-list-item v-for="question in questionsItems" :key="question.id" v-ripple="phoneOnly" @click="questionDetailsDialog = true; questionDetails = question" class="questions-item">
                            <v-list-item-icon>
                                <v-icon color="strong-text">{{question.type === 'essay' ? 'mdi-text-box-outline' : 'mdi-file-question-outline'}}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{question.name}}</v-list-item-title>
                                <v-list-item-subtitle>
                                    <v-chip color="grey lighten-4" small label class="me-1 px-2" style="height: 20px">
                                        #{{question.id}}
                                    </v-chip>
                                    <question-difficulty :level="question.difficulty_level" class="me-1" />

                                    <v-chip v-if="question.type === 'essay'" color="grey lighten-4" small label class="me-1 px-2" style="height: 20px">
                                        <v-icon size="14" class="me-1">mdi-card-text-outline</v-icon>
                                        <span class="small-text">سؤال مقالي</span>
                                    </v-chip>

                                    <v-chip v-if="question.answers.find(answer=>!!answer.correct)" color="grey lighten-4" small label class="me-1 px-2" style="height: 20px">
                                        <span class="small-text me-1">الإجابة: </span>
                                        <v-icon v-if="question.answers.find(answer=>!!answer.correct).image_url && !question.answers.find(answer=>!!answer.correct).text" small>mdi-image</v-icon>
                                        <span v-else>{{textMax(question.answers.find(answer=>!!answer.correct).text, 40)}}</span>
                                    </v-chip>

                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-icon>
                                <v-btn icon color="primary" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop="questionDetailsDialog = true; questionDetails = question;">
                                    <v-icon size="22">mdi-file-eye-outline</v-icon>
                                </v-btn>
                                <v-btn icon color="text" :to="{name: 'edit-question', params: {id: question.id}}" @mousedown.stop @mouseover.stop @touchstart.stop>
                                    <v-icon size="22">mdi-square-edit-outline</v-icon>
                                </v-btn>
                                <v-btn icon color="error" @mousedown.stop @mouseover.stop @touchstart.stop @click.stop="deleteQuestionDialog = true; deleteQuestion = question;">
                                    <v-icon size="22">mdi-delete-outline</v-icon>
                                </v-btn>
                            </v-list-item-icon>
                        </v-list-item>
                    </v-list>
                </div>
                <div v-else class="py-2">
                    <v-alert text type="info" color="blue-grey darken-1">
                        <b>التصنيف فارغ: </b> هذا التصنيف لا يحتوي على أي أسئلة أو تصنيفات فرعية
                    </v-alert>
                </div>
            </v-card-text>
        </v-card>


        <div class="actions">
            <!-- <action-dialog v-model="updateMaxTokensDialog" max-width="380" action="put" :url="`/users/${id}`" :data="{max_tokens: maxTokens}" title="تعديل عدد اﻷجهزة" subtitle="تعديل عدد الأجهزة المسموح لها بالدخول إلى هذا الحساب" button-text="حفظ" button-color="primary" @sync="sync" @reset="maxTokens = ''">
                <v-text-field v-model="maxTokens" type="number" :min="1" label="الحد اﻷقصى للأجهزة"></v-text-field>
            </action-dialog> -->

            <action-dialog v-model="renameDialog" action="put" :url="`/exams/categories/${editedDirectory.id}`" success-msg="تم حفظ التغييرات بنجاح" title="تعديل التصنيف" button-text="حفظ" :data="{name: editedDirectory.name}" @reset="editedDirectory.id = null; editedDirectory.name = '';" @sync="syncDirectory">
                <v-text-field v-model="editedDirectory.name" autofocus label="name"></v-text-field>
            </action-dialog>

            <action-dialog v-model="deleteDirectoryDialog" action="delete" :url="`/exams/categories/${deleteDirectory ? deleteDirectory.id : ''}`" title="حذف التصنيف" button-text="تأكيد الحذف" button-color="error" @sync="deleteDirectoryItem(deleteDirectory.id)">
                <div v-if="deleteDirectory">
                    <p class="strong-text--text mb-0">
                        هل أنت متأكد من حذف التصنيف <b class="strong-text--text">"{{deleteDirectory.name}}"</b> ؟
                    </p>
                </div>
            </action-dialog>

            <action-dialog v-model="deleteQuestionDialog" action="delete" :url="`/exams/questions/${deleteQuestion ? deleteQuestion.id : ''}`" title="حذف السؤال" button-text="تأكيد الحذف" button-color="error" @sync="deleteQuestionItem(deleteQuestion.id)">
                <div v-if="deleteQuestion">
                    <p class="strong-text--text mb-0">
                        هل أنت متأكد من حذف السؤال <b class="strong-text--text">"{{deleteQuestion.name}}"</b> ؟
                    </p>
                </div>
            </action-dialog>

            <action-dialog v-model="createDirectoryDialog" action="post" :url="`/exams/categories`" success-msg="تم إنشاء التصنيف" title="تصنيف جديد" button-text="إنشاء" :data="{name: newCategoryName, parent_category_id: currentDirectory ? currentDirectory.id : null}" @reset="newCategoryName = '';" @sync="addDirectory">
                <v-text-field v-model="newCategoryName" autofocus label="اسم التصنيف" placeholder="أدخل اسم التصنيف"></v-text-field>
            </action-dialog>

            <question-details v-model="questionDetailsDialog" :question-details="questionDetails" />
        </div>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import QuestionDetails from '@/components/custom/questions-details'
import QuestionDifficulty from '@/components/custom/question-difficulty'

export default {
    components: {
        QuestionDetails,
        QuestionDifficulty
    },
    props: {
        categories: {},
        questions: {},
        current_directory: {},
    },
    data() {
        return {
            page_url: '/exams/questions',

            renameDialog: false,
            editedDirectory: {
                id: null,
                name: '',
            },

            createDirectoryDialog: false,
            newCategoryName: '',

            deleteDirectoryDialog: false,
            deleteDirectory: null,

            deleteQuestionDialog: false,
            deleteQuestion: null,

            questionDetailsDialog: false,
            questionDetails: null,

            currentDirectory: null,
            directories: null,
            questionsItems: null,
        }
    },
    computed: {
        ...GlobalComputed,
    },
    watch: {
        categories(categories){
            this.directories = categories && categories.data ? categories.data : [];
        },
        questions(questions){
            this.questionsItems = questions && questions.data ? questions.data : [];
        },
        current_directory(current_directory){
            this.currentDirectory = current_directory ? current_directory.data || current_directory: null;
        },
    },
    methods: {
        ...GlobalMethods,
        navigateToPath(path){
            if (path === '/'){
                this.$router.push({query: {}});
            }else{

                this.$router.push({query: {path: path.replaceAll('/', '_')}});
            }
        },
        openRenameDirectoryDialog(dir){
            Object.assign(this.editedDirectory, dir);
            this.renameDialog = true;
        },
        syncDirectory(newItem){
            this.directories = this.directories.map(item=>{
                if (item.id === newItem.id){
                    return Object.assign(item, newItem);
                }
                return item;
            })
        },
        addDirectory(newItem){
            this.directories.push(newItem);
        },
        deleteDirectoryItem(id){
            this.directories = this.directories.filter(item=>{
                return item.id !== id;
            });
        },
        deleteQuestionItem(id){
            this.questionsItems = this.questionsItems.filter(item=>{
                return item.id !== id;
            });
        },
        setShortcutsListener(){
            window.addEventListener('keypress', e=>{
                // if key is "N"
                if (e.keyCode === 78 || e.which === 78){
                    if (e.shiftKey){
                        // CTRL + N
                        e.preventDefault();
                        this.createDirectoryDialog = true;
                    }
                }
            })
        },
        setData(){
            this.currentDirectory = this.current_directory ? this.current_directory.data || this.current_directory : null;
            if (this.categories){
                this.directories = this.categories.data || [];
            }else{
                this.directories = [];
            }
            
            if (this.questions){
                this.questionsItems = this.questions.data || [];
            }else{
                this.questionsItems = [];
            }
        },
        textMax(text, length){
            return text ? (text.length > length ? text.slice(0, length) + ' ...' : text) : '';
        },
    },
    created(){
        this.setData();
        this.setShortcutsListener()
    }
}

</script>
<style lang="scss" scoped>
.v-list--two-line{
    .directories-item, .questions-item{
        &.v-list-item .v-list-item__icon{
            margin-bottom: 16px!important;
        }
    }
}
</style>
